import _regeneratorRuntime from "/opt/atlassian/pipelines/agent/build/packages/admin/node_modules/@babel/runtime/regenerator";
import _asyncToGenerator from "/opt/atlassian/pipelines/agent/build/packages/admin/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
// Authentication
import feathers, { authentication, socketio } from '@feathersjs/client';
import io from 'socket.io-client';
import { CookieStorage } from 'cookie-storage';
import ReactGA from 'react-ga';
import { hotjar } from 'react-hotjar';
var app = feathers(); // If this is a production (build) environment, use the API_URL

var socket = io(process.env.NODE_ENV === 'production' && process.env.REACT_APP_API_URL || '');
app.configure(socketio(socket, {
  timeout: 20000
}));
var cookieStorage = new CookieStorage({
  path: '/',
  domain: process.env.REACT_APP_COOKIE_DOMAIN || ''
});
app.configure(authentication({
  entity: 'user',
  service: 'user',
  storage: cookieStorage
}));
app.on('authenticated',
/*#__PURE__*/
function () {
  var _ref = _asyncToGenerator(
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee(token) {
    var payload, millis, timeout;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return app.passport.verifyJWT(token.accessToken);

          case 2:
            payload = _context.sent;
            // Refresh the token 5 minutes before it expires
            millis = payload.exp * 1000 - new Date().getTime() - 5 * 60 * 1000;
            timeout = setTimeout(function () {
              return app.authenticate();
            }, millis); // Clear the timeout if the user logs out
            // @todo should this only be called once?

            app.on('logout', function () {
              return clearTimeout(timeout);
            });

          case 6:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function (_x) {
    return _ref.apply(this, arguments);
  };
}());

if (process.env.NODE_ENV === 'production') {
  // Google analytics for production only
  if (process.env.REACT_APP_GA_ID) {
    ReactGA.initialize(process.env.REACT_APP_GA_ID);
  } // Hotjar for production only


  if (process.env.REACT_APP_HOTJAR_ID && process.env.REACT_APP_HOTJAR_SNIPPET_VERSION) {
    hotjar.initialize(process.env.REACT_APP_HOTJAR_ID, process.env.REACT_APP_HOTJAR_SNIPPET_VERSION);
  }
}

export default app;